/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Add_TextInputs */

const en_story_add_text = /** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add text overlay...`)
};

const es_story_add_text = /** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir texto...`)
};

const fr_story_add_text = /** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter du texte...`)
};

const de_story_add_text = /** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text hinzufügen...`)
};

const id_story_add_text = /** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan hamparan teks...`)
};

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const ja_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const zh_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const ar_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const it_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const ru_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const pt_story_add_text = en_story_add_text;

/** @type {(inputs: Story_Add_TextInputs) => LocalizedString} */
const ko_story_add_text = en_story_add_text;

/**
* | output |
* | --- |
* | "Add text overlay..." |
*
* @param {Story_Add_TextInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_add_text = /** @type {((inputs?: Story_Add_TextInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Add_TextInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_add_text(inputs)
	if (locale === "es") return es_story_add_text(inputs)
	if (locale === "fr") return fr_story_add_text(inputs)
	if (locale === "de") return de_story_add_text(inputs)
	if (locale === "ja") return ja_story_add_text(inputs)
	if (locale === "zh") return zh_story_add_text(inputs)
	if (locale === "ar") return ar_story_add_text(inputs)
	if (locale === "id") return id_story_add_text(inputs)
	if (locale === "it") return it_story_add_text(inputs)
	if (locale === "ru") return ru_story_add_text(inputs)
	if (locale === "pt") return pt_story_add_text(inputs)
	return ko_story_add_text(inputs)
});